import createCrud from '../../crud';

export default createCrud({
    resource: 'tags',
    getters: {}
  });